import { useState, useEffect } from 'react';
export const useDebounce = (value:string, delay:number): string => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
  );
  return debouncedValue;
}
